import { Box, Typography } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router';

import { useGetFiatAccountQuery } from '@/api/v1';
import { FiatPaymentMethodCard } from '@/components/organisms/FiatPaymentMethodCard';
import { useTranslator } from '@/hooks/useTranslator';

export const AccountPaymentMethods: React.FC = (): React.ReactElement => {
  const { accountId = '' } = useParams();
  const tr = useTranslator();
  const { data: paymentMethod } = useGetFiatAccountQuery(accountId);

  if (!paymentMethod) {
    console.debug(`payment ${accountId} method not found`);
    return <></>;
  }

  return (
    <Box px={4} mt={4}>
      <Typography fontSize={20} fontWeight={500} lineHeight="32px">
        {tr('PAYMENT_METHODS')}
      </Typography>
      <Box display="flex" flexDirection="column" gap={2} mt={3}>
        <FiatPaymentMethodCard paymentMethod={paymentMethod} />
      </Box>
    </Box>
  );
};
